import { render, staticRenderFns } from "./HomeFourth.vue?vue&type=template&id=d5046284&scoped=true"
import script from "./HomeFourth.vue?vue&type=script&lang=js"
export * from "./HomeFourth.vue?vue&type=script&lang=js"
import style0 from "./HomeFourth.vue?vue&type=style&index=0&id=d5046284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5046284",
  null
  
)

export default component.exports